import React from 'react'
import ThanksComp from '../components/BookCourt/ThanksComp'

const Thanks = () => {
  return (
    <>
        <ThanksComp/> 
    </>
  )
}

export default Thanks